import { render, staticRenderFns } from "./financeiro-sub-especialidade.vue?vue&type=template&id=a19cfa38&scoped=true"
import script from "./financeiro-sub-especialidade.vue?vue&type=script&lang=ts"
export * from "./financeiro-sub-especialidade.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-sub-especialidade.vue?vue&type=style&index=0&id=a19cfa38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19cfa38",
  null
  
)

export default component.exports